import { IBidRequest, IS2SBidRequest } from '../../../../typings/IPrebid'
import SlotRepository from '../../../slots/SlotRepository'

/**
 * store normalized codes, so they don't have
 * to re-run
 */
const NormalizedCodeMap = {}

/**
 * adds the refresh count to each bid, and caches locally
 * adUnitCode normalizations
 */
export function addSlotLevelData(bids: Array<IS2SBidRequest>): void {
  bids.forEach((bid) => {
    if (bid.adUnitCode) {
      const slotId =
        NormalizedCodeMap[bid.adUnitCode] || normalizeAdUnitCode(bid.adUnitCode)
      NormalizedCodeMap[bid.adUnitCode] = slotId

      const slot = SlotRepository.getSlotById(slotId)
      bid.refreshCount = slot?.refreshes
      bid.adunitPath = slot?.adUnitPath
    }
  })
}

/**
 * outstream and ibv adUnitCodes are tied
 * to the slotId that doesnt contain those names
 */
const ALTERNATE_ADUNITCODES = new RegExp(
  /_outstream_desktop|_outstream_mobile|_ibv_desktop|_ibv_mobile/
)

/**
 * normalizes adUnitCodes to match
 * slot id names
 *
 * alternate codes set in AuctionHouse convertOutstreamBidsAdunits
 */
export function normalizeAdUnitCode(adUnitCode: string): string {
  let newCode = adUnitCode.replace(ALTERNATE_ADUNITCODES, '')

  // if not adhesion, desktop -> btf
  if (newCode.indexOf('adhesion') === -1) {
    newCode = newCode.replace('desktop', 'btf')
  }

  return newCode
}
